// API Base URL from environment variable
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://solutions1.jo.zain.com";

// For later use in shaa Allah
export const API_ENDPOINTS = {
};
